<template>

       <i class="fa-solid fa-ticket menu-icon-trigger"></i>




    <el-drawer v-model="drawer" direction="rtl" :before-close="handleClose">
        <template #header>
            <h4>New Ticket</h4>
        </template>
        <template #default>
            <el-form
                label-position="top"
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item class="mr-2" label="Department" prop="department">
                            <el-select v-model="form.department"  placeholder="Select"  style="width:100%" >
                                <el-option
                                    v-for="item in departments"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="form.department=='Sales'">
                        <el-form-item class="ml-2" label="Agent" >
                            <el-select v-model="form.created_for" value-key="id" placeholder="Select Agent" >
                                <el-option
                                    v-for="item in salesteam"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"


                                >

                                    <el-avatar class="mr-2 " :size="20" :src="'https://crm.pickotrip.com/images/agents/'+item.name+'.jpg'" />
                                    {{ item.name }}



                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    <el-form-item label="Priority Level" class="ml-2"  prop="priority">
                        <el-select v-model="form.priority"  placeholder="Select"  style="width:100%" >
                            <el-option
                                v-for="item in priorities"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Category"  prop="category">
                            <el-select v-model="form.category"  placeholder="Select"  style="width:100%" >
                                <el-option
                                    v-for="item in categories()"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                            <el-input class="mt-2" v-if="form.category=='Other'" v-model="form.othercategory"  placeholder="Enter Category" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Enquiry/Booking ID" prop="enquiryid">

                            <el-input class="mt-2" type="number" v-model="form.enquiryid"  placeholder="Enter ID" :disabled="enquiryid!=null">
                                <template #prepend>
                                    CDM
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Description"  prop="description">

                            <el-input class="mt-2" :rows="5"  type="textarea" v-model="form.description"  placeholder="Enter Description" >
                                <template #prepend>
                                    CDM
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="Attachments">

                            <el-upload
                                ref="uploadRef"
                                class="upload-demo"
                                action=""
                                :auto-upload="false"
                                :on-change="fileadded"
                                :on-remove="fileadded"
                            >
                                <template #trigger>
                                    <el-button type="primary">select file</el-button>
                                </template>

                                <template #tip>
                                    <div class="el-upload__tip">
                                        jpg/png/pdf/doc/xlsx files
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>


                </el-row>



            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">

                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Raise Ticket</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElMenuItem,
    ElInput,
    ElSelect,
    ElOption,
    ElFormItem,
    ElForm,
    ElCol,
    ElRow,
    ElButton,
    ElCard,
    ElDivider,
    ElDrawer,
    ElDatePicker, ElTag, ElAvatar, ElSkeleton,ElUpload,ElMessage
} from 'element-plus'
import 'element-plus/dist/index.css'
export default {
    name: "NewTicket",
    components: { ElMenuItem,ElInput,ElUpload,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElDrawer,ElSkeleton },
    props:{
        enquiryid: {
            type: Number,
            default () {
                return null
            }
        },
    },
    data() {
        return {
            drawer: false,
            loading:false,
            form: {
                department: '',
                category:'',
                othercategory:'',
                priority:'',
                enquiryid:'',
                description:'',
                files:[],
                created_for:''
            },
            departments:[],
            salesteam:[],
            allcategories:[],
            priorities:[
                {
                    value:'0',
                    label:'Low'
                },
                {
                    value:'1',
                    label:'Medium'
                },
                {
                    value:'2',
                    label:'High'
                },
                {
                    value:'3',
                    label:'Urgent'
                },

            ],
            rules:{
                department: [{ required: true, trigger: 'change', message:'' }],
                category: [{ required: true, trigger: 'change', message:'' }],
                priority: [{ required: true, trigger: 'change', message:'' }],
                description: [{ required: true, trigger: 'change', message:'' }],
            }
        }
    },
    created()
    {
        if (this.enquiryid != null) {
            this.form.enquiryid = this.enquiryid;
        }
        this.getdata();
    },
    methods: {
        open() {
            this.drawer = true;
        },
        handleClose() {
            this.drawer=false

        },
        categories(){


            if(this.allcategories[this.form.department]){
                return this.allcategories[this.form.department];
            }
            else{
                return ['Other'];
            }
        },
        getdata(){
            let currentObj = this;
            axios.get('/tickets/create').then(function (response) {

                currentObj.departments=response.data.departments;
                currentObj.allcategories=response.data.categories;
                currentObj.salesteam=response.data.salesteam;
            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    this.form.files.map(function(file, key) {
                        formData.append('attachments[]', file);
                    });

                    formData.append('department', this.form.department);
                    formData.append('category', this.form.category);
                    formData.append('othercategory', this.form.othercategory);
                    formData.append('priority', this.form.priority);
                    formData.append('enquiryid', this.form.enquiryid);
                    formData.append('description', this.form.description);
                    formData.append('created_for', this.form.created_for);


                    axios.post('/tickets',formData, config).then(function (response) {

                        currentObj.loading=false;
                        ElMessage({
                            showClose: true,
                            message: 'Ticket Raised Succesfully.',
                            type: 'success',
                        });
                        formEl.resetFields();
                        currentObj.form.files=[];
                        currentObj.form.othercategory="";
                        currentObj.$refs.uploadRef.clearFiles();

                    })
                        .catch(function (error) {
                            currentObj.loading=false;
                        });
                } else {

                    return false
                }
            })
        },
        fileadded(uploadFile, uploadFiles){
            this.form.files=[];

            let currentObj = this;
            uploadFiles.map(function(value, key) {
                console.log(value.raw);
                currentObj.form.files.push(value.raw);
            });
        }
    }
}
</script>

<style scoped>

</style>
